import React, { useState, useEffect } from 'react'
import PlayerHistoryHomeNavigation from './PlayerHistoryHomeNavigation'
import './StatsAndStandingsHome.css'
import SearchForPlayer from '../UIElements/SearchForPlayer'
import Banner from './Banner'

const PlayerHistoryHome = () => {
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 440)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 440)
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	return (
		<div>
			<PlayerHistoryHomeNavigation />
			{!isMobile && (
				<div style={{ marginTop: '5rem' }}>
					<Banner />
				</div>
			)}
			{isMobile && (
				<div style={{ marginTop: '5rem' }}>
					<SearchForPlayer />
				</div>
			)}
			{!isMobile && (
				<div style={{ marginTop: '1rem' }}>
					<SearchForPlayer />
				</div>
			)}
		</div>
	)
}

export default PlayerHistoryHome
